import { create } from 'zustand';

interface IMiningData {
  amount: number;
  amount_usdt: number;
  characters_used: number[];
  date_end: string;
  date_start: string;
  id: number;
  status: string;
  user_id: number;
  last_boost_time: string;
  adsgram_ads_allowed: boolean;
}

export interface IMiningState {
  mining: IMiningData;
  last_boost_time: string;
  original_date_end: string;
  adsgram_ads_allowed: boolean;
}

export interface MiningStore {
  miningData: IMiningState | null;
  lastBoostTime: string | null;
  adsgramAdsAllowed: boolean;
  setMiningData: (data: IMiningState) => void;
  updateMiningStatus: (status: 'process' | 'claim' | 'done') => void;
  
  getAmount: () => number | null;
  getAmountUsdt: () => number | null;
  getDateStart: () => string | null;
  getDateEnd: () => string | null;
  getOriginalDateEnd: () => string | null;
  getLastBoostTime: () => string | null;
  getAdsgramAdsAllowed: () => boolean | null;
  setLastBoostTime: (time: string) => void;
  setAdsgramAdsAllowed: (allowed: boolean) => void;
}

export const useMiningStore = create<MiningStore>((set, get) => ({
  miningData: null,
  lastBoostTime: null,
  adsgramAdsAllowed: false,
  setMiningData: (data) => {
    set({
      miningData: data,
      lastBoostTime: data.mining.last_boost_time,
      adsgramAdsAllowed: data.mining.adsgram_ads_allowed
    });
  },
  updateMiningStatus: (status) => 
    set((state) => ({
      miningData: state.miningData ? {
        ...state.miningData,
        mining: {
          ...state.miningData.mining,
          status
        }
      } : null
    })),
  
  getAmount: () => get().miningData?.mining.amount ?? null,
  getAmountUsdt: () => get().miningData?.mining.amount_usdt ?? null,
  getDateStart: () => get().miningData?.mining.date_start ?? null,
  getDateEnd: () => get().miningData?.mining.date_end ?? null,
  getOriginalDateEnd: () => get().miningData?.original_date_end ?? null,
  getLastBoostTime: () => get().lastBoostTime,
  getAdsgramAdsAllowed: () => get().adsgramAdsAllowed,
  setLastBoostTime: (time) => set({ lastBoostTime: time }),
  setAdsgramAdsAllowed: (allowed) => set({ adsgramAdsAllowed: allowed })
}));
